import React from "react";
import { Box, Typography } from "@mui/material";
import { Draggable } from "@hello-pangea/dnd";
import KanbanCard from "./KanbanCard";

interface KanbanColumnProps {
  title: string;
  color: string;
  items: any[];
}

const KanbanColumn: React.FC<KanbanColumnProps> = ({ title, color, items }) => (
  <Box
    sx={{
      backgroundColor: "#F5F5F5",
      borderRadius: 2,
      p: 2,
      display: "flex",
      flexDirection: "column",
      height: 800,
    }}
  >
    {/* Header */}
    <Box sx={{ position: "sticky", top: 0, backgroundColor: "#F5F5F5", zIndex: 1 }}>
      <Typography
        variant="h6"
        sx={{ color, mb: 1, display: "flex", alignItems: "center", gap: 1 }}
      >
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: color,
          }}
        />
        {title} ({items.length})
      </Typography>
    </Box>

    {/* Cards */}
    <Box sx={{ flex: 1, overflowY: "auto", pr: 1 }}>
      {items.map((item, index) => (
        <Draggable draggableId={item.id.toString()} index={index} key={item.id}>
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              style={{
                marginBottom: 8,
                ...provided.draggableProps.style,
              }}
            >
              <KanbanCard {...item} />
            </div>
          )}
        </Draggable>
      ))}
    </Box>
  </Box>
);

export default KanbanColumn;
